import { useTranslation } from 'react-i18next';
import { LoadingIndicator } from './LoadingIndicator';

// ツール実行中のインジケーターコンポーネント
export function ToolExecutingIndicator({
  toolName,
  state,
}: {
  toolName: string;
  state: 'input-streaming' | 'input-available';
}) {
  const { t } = useTranslation();
  const stateLabel =
    state === 'input-streaming' ? t('viewModel.toolExecuting.preparing') : t('viewModel.toolExecuting.executing');

  return (
    <LoadingIndicator>
      <span>
        {toolName} {stateLabel}...
      </span>
    </LoadingIndicator>
  );
}
